import React from 'react';
import Modal from 'react-modal';

const customStyles = {
    content : {
        position: 'absolute',
        top: '10%',
        left: '25%',
        height: '70%',
        width: '50%'
    },
    overlay : {zIndex: 20001}
};

const imgStyle = {
  display: 'block',
  marginLeft: 'auto',
  marginRight: 'auto',
  width: '80%'
};

class FloorplanModal extends React.Component {
    render() {
        const {floorplanURL} = this.props
        return (
            <Modal
                isOpen={this.props.isOpen}
                onRequestClose={this.props.onRequestClose}
                style={customStyles}>
                <h3>Floor Plan</h3>
                <img style={imgStyle} alt="" src={floorplanURL}/>
            </Modal>
        )
    }
}

export default FloorplanModal;
